<template>
  <div style="height: 100%; max-width: 500px" class="mx-auto">
    <div v-if="!loadingpdpa" style="height: 100%">
      <Term
        v-if="showTerm && termCondition"
        @onAgree="onAgree"
        v-model="termCondition"
      ></Term>
      <div v-else>
        <v-stepper
          class="elevation-0 pa-0"
          v-model="step"
          style="border-radius: 0px"
        >
          <v-stepper-content class="pa-0" step="1">
            <step-1 @nextstep="step++"></step-1>
          </v-stepper-content>
          <v-stepper-content class="pa-0" step="2">
            <step-2 @prevstep="step--" @nextstep="step++"></step-2>
          </v-stepper-content>
          <v-stepper-content class="pa-0" step="3">
            <step-3 @prevstep="step--" @nextstep="step++"></step-3>
          </v-stepper-content>
          <v-stepper-content class="pa-0" step="4">
            <step-4
              v-if="step == 4"
              @prevstep="step--"
              @nextstep="step++"
            ></step-4>
          </v-stepper-content>
          <v-stepper-content class="pa-0" step="5">
            <step-5 @prevstep="step--" @nextstep="step++"></step-5>
          </v-stepper-content>
        </v-stepper>
      </div>
    </div>
    <div v-else>
      <div class="text-center mt-2">
        <img width="62px" src="@/assets/logo.png" />
      </div>
      <div class="text-center">
        <v-progress-circular
          size="65"
          color="primary"
          indeterminate
          class="mt-10"
        ></v-progress-circular>
      </div>
    </div>
  </div>
</template>

<script>
import Step1 from "./Step1.vue";
import Step2 from "./Step2.vue";
import Step3 from "./Step3.vue";
import Step4 from "./Step4.vue";
import Step5 from "./Step5.vue";
import Term from "./Term.vue";
import axios from "axios";
export default {
  components: {
    Term,
    Step1,
    Step2,
    Step3,
    Step4,
    Step5,
  },
  data() {
    return {
      step: 1,
      showTerm: false,
      loadingpdpa: false,
      termCondition: null,
    };
  },
  async mounted() {
    // this.showTerm = await this.getPdpa();
    // this.loadingpdpa = false;
    // await this.handleGetPdpa();
  },
  methods: {
    async handleGetPdpa() {
      const vm = this;
      try {
        const data = {
          userid: vm.userid,
          pageid: vm.query.pageid,
        };

        vm.loadingpdpa = true;
        let response = null;
          response = await vm.getNewPdpa(data);
        vm.loadingpdpa = false;

        if (response && response.status === 200) {
          vm.termCondition = response.data.term_condition;
          vm.showTerm = !response.data.pdpa;
        } else {
          await this.$swal.fire({
            text: response.data.reason,
          });
          if (response.data.responsecode == 400) {
            this.$liff.closeWindow();
          }
        }
      } catch (error) {
        console.error(error);
      }
    },
    async getNewPdpa(data) {
      const vm = this;
      try {
        const url = `${vm.serverUrl}toacrm/api/liff/pdpa`;
        const response = await axios.get(url, {
          headers: { AUTHORIZATION: "Bearer xxx xxx" },
          params: data,
        });

        if (response) {
          return response;
        } else {
          return null;
        }
      } catch (error) {
        console.error(error);
      }
    },
    async getPdpa(data) {
      const vm = this;
      try {
        const url = `${vm.serverUrl}toacrm/pdpa`;
        const response = await axios.get(url, {
          headers: { AUTHORIZATION: "Bearer xxx xxx" },
          params: data,
        });

        if (response) {
          return response;
        } else {
          return null;
        }
      } catch (error) {
        console.error(error);
      }
    },
    onAgree() {
      this.showTerm = false;
    },
  },
};
</script>

<style lang="scss" scoped></style>
